import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { BASE_VIEW_OPTIONS } from '../../utils/DataConstants';
import { savedFilterViewsRestCrudThunksForBuyer } from '../../thunks/saved_filter_views_thunks';
import {
	getAttentionDashboard,
	updateAttentionDashboard,
} from '../../thunks/attention_dashboard_thunks';
import { withUserType } from '../withUserType';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import { useWorkOrdersViewTabs, WORK_ORDERS_OVERVIEW_TABS_COLLECTION } from './useViewTabs';
import OverviewShell from '../overview_shell/OverviewShell';

interface WorkOrdersOverviewPageProps {
	companyConfig: any;
	childRoutes: any[];
	defaultView: any;
	getWorkOrderDefaultView: () => Promise<any>;
	fetchWorkOrderViews: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection?
	) => Promise<any>;
	workOrderViews: any[];
	workOrderViewsLoading: boolean;
	attentionDashboards: any;
	saveAttentionDashboard: (entity: any) => Promise<any>;
}

const WorkOrdersOverviewPage = ({
	childRoutes,
	defaultView,
	getWorkOrderDefaultView,
	fetchWorkOrderViews,
	workOrderViews,
	workOrderViewsLoading,
	attentionDashboards,
	saveAttentionDashboard,
}: WorkOrdersOverviewPageProps): React.ReactElement => {
	const { loading, redirectTarget, tabs, handleTabChange, checkTabActive, tabsRightActions } =
		useWorkOrdersViewTabs({
			basePath: '/buyer/workOrders/overview',
			baseViewOptions: BASE_VIEW_OPTIONS,
			defaultView,
			workOrderViews,
			workOrderViewsLoading,
			attentionDashboards,
			saveAttentionDashboard,
			fetchWorkOrderViews,
			getWorkOrderDefaultView,
		});

	if (loading) return null;
	return (
		<>
			<Route
				path="/buyer/workOrders/overview"
				exact
				render={() => <Redirect to={redirectTarget} />}
			/>
			<OverviewShell
				title="Work Orders"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="workOrdersPage"
				tabsRightActions={tabsRightActions}
				tabsClassName="items-center justify-start"
				creationRoutes={['new', 'newWorkOrder']}
			/>
		</>
	);
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	getWorkOrderDefaultView: () => getAttentionDashboard(dispatch, ownProps.userType),
	fetchWorkOrderViews: (
		params,
		targetCollectionName = WORK_ORDERS_OVERVIEW_TABS_COLLECTION,
		pagination = { current: 1, pageSize: 100 },
		sorting?,
		filters?,
		addToTargetCollection?
	) =>
		dispatch(
			savedFilterViewsRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	saveAttentionDashboard: (entity) => updateAttentionDashboard(dispatch, ownProps.userType, entity),
});

const mapStateToProps = (state) => ({
	companyConfig: state.company_config,
	defaultView: state.session.defaultView,
	workOrderViews: getRecordsForTargetCollection(
		state.saved_filter_views,
		WORK_ORDERS_OVERVIEW_TABS_COLLECTION
	),
	workOrderViewsLoading: nullSafeGet(
		`${WORK_ORDERS_OVERVIEW_TABS_COLLECTION}.fetching`,
		state.saved_filter_views
	),
	attentionDashboards: state.attention_dashboards.detail,
});

export default withRouter(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(WorkOrdersOverviewPage))
);
